import { Input, InputAdornment } from '@mui/material';

import SearchIcon from '../assets/input-icons/search.svg?react';
import palette from '../theme/palette';

export interface SearchInputProps {
  onChange: (value: string) => void;
  value?: string;
  placeholder?: string;
  height?: string;
  width?: string;
  backgroundColor?: string;
}

const SearchInput = ({
  value,
  height,
  placeholder = '',
  width,
  onChange,
  backgroundColor
}: SearchInputProps) => (
  <Input
    disableUnderline
    type="search"
    value={value}
    placeholder={placeholder}
    sx={{
      '& .MuiInputBase-input::placeholder': {
        fontWeight: 500,
        fontSize: '12px',
        opacity: 1,
        color: palette.grey[400]
      },
      alignItems: 'center',
      backgroundColor: backgroundColor ? backgroundColor : palette.white,
      padding: '8px',
      height: height ? height : '31px',
      width: width ? width : '178px',
      borderRadius: '88px'
    }}
    startAdornment={
      <InputAdornment position="start">
        <SearchIcon />
      </InputAdornment>
    }
    onChange={e => onChange(e.target.value)}
  />
);

export default SearchInput;
